module.exports = __webpack_public_path__ + "img/ics_o_clock_warning_red.11c13141.svg";